<div class="services-filter-configuration-wrap">
  <h3>Services filter configuration</h3>
  <form [formGroup]="form">
    <div class="wrap">
      <mat-checkbox class="show-checkbox" formControlName="show">Show Services filter</mat-checkbox>
      <div class="wrap">
        @if (form.get('show').value) {
          <mat-form-field appearance="fill" class="item">
            <mat-label>Special placeholder path</mat-label>
            <input matInput formControlName="specialPlaceholderPath">
          </mat-form-field>
        }
      </div>
    </div>
  </form>
</div>